import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Icon } from "@azim-crm/icons";
import { Button } from "../Button/Button.js";
import styles from "./RowConfirm.module.css";
const toneIcon = {
    warning: "alertTriangle",
    danger: "trash",
};
/**
 * Confirmação dentro da linha do Azim CRM (RowConfirm).
 * Substitui a linha original por uma célula de largura total (`colSpan`) com
 * a pergunta e as ações. Foca o botão de confirmação ao abrir e devolve o
 * foco ao elemento que tinha foco antes, ao fechar (confirmar ou cancelar).
 */
export function RowConfirm({ colSpan, tone, message, confirmLabel, onConfirm, onCancel, busy = false }) {
    const confirmRef = useRef(null);
    useEffect(() => {
        const previousFocus = document.activeElement;
        confirmRef.current?.focus();
        return () => {
            previousFocus?.focus();
        };
    }, []);
    return (_jsx("tr", { className: styles.row, children: _jsx("td", { colSpan: colSpan, className: [styles.cell, styles[tone]].filter(Boolean).join(" "), children: _jsxs("div", { className: styles.content, role: "alert", children: [_jsx(Icon, { name: toneIcon[tone], size: 18, className: styles.icon ?? "" }), _jsx("div", { className: styles.message, children: message }), _jsxs("div", { className: styles.actions, children: [_jsx(Button, { type: "button", variant: "secondary", size: "sm", onClick: onCancel, disabled: busy, children: "Cancelar" }), _jsx(Button, { ref: confirmRef, type: "button", variant: tone === "danger" ? "danger" : "primary", size: "sm", onClick: onConfirm, disabled: busy, children: confirmLabel })] })] }) }) }));
}
//# sourceMappingURL=RowConfirm.js.map